"use strict";

import "promise-polyfill/src/polyfill";
import "whatwg-fetch";

import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ApplicationLocaleBoundary from "../i18n/ApplicationLocaleBoundary";
import { i18n } from "../i18n/i18next";
import { history, persistor, store } from "../redux/store";
import { HistoryRouter } from "./HistoryRouter";
import { MantineRoot } from "./MantineRoot";

const mountDivName = "react-container";
let container;

function getRoot() {
    if (container) {
        return null;
    }

    container = document.getElementById(mountDivName);
    return createRoot(container);
}

export function render(Component) {
    const root = getRoot();
    if (!root) {
        return;
    }

    root.render(
        <I18nextProvider i18n={i18n}>
            <MantineRoot>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <ApplicationLocaleBoundary>
                            <Component />
                        </ApplicationLocaleBoundary>
                    </PersistGate>
                </Provider>
            </MantineRoot>
        </I18nextProvider>
    );
}

export function routerRender(Component) {
    const root = getRoot();
    if (!root) {
        return;
    }

    root.render(
        <I18nextProvider i18n={i18n}>
            <MantineRoot>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <ApplicationLocaleBoundary>
                            <HistoryRouter history={history}>
                                <Component />
                            </HistoryRouter>
                        </ApplicationLocaleBoundary>
                    </PersistGate>
                </Provider>
            </MantineRoot>
        </I18nextProvider>
    );
}
